module.exports = __webpack_public_path__ + "img/mobile/Prompts-gameintro/288_symbol_scatter@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Prompts-gameintro/288_symbol_scatter@1x.png
// module id = 725
// module chunks = 0